import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addProduct } from '../redux/products/actions';

const AddProductForm = () => {
  const dispatch = useDispatch();

  const initialState = {
    name: '',
    category: '',
    image: '',
    price: '',
    quantity: '',
  };

  const [newProduct, setNewProduct] = useState(initialState);
  const { name, category, image, price, quantity } = newProduct;

  const handleChange = (e) => {
    setNewProduct((prevNewProduct) => {
      return {
        ...prevNewProduct,
        [e.target.name]:
          e.target.type === 'text' ? e.target.value : Number(e.target.value),
      };
    });
  };

  const isValid = !!(
    name &&
    category &&
    image &&
    price &&
    quantity &&
    price > 0 &&
    quantity > 0
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    setNewProduct(initialState);
    dispatch(addProduct({ ...newProduct, originalQty: quantity }));
  };

  return (
    <div className="formContainer">
      <h4 className="formTitle">Add New Product</h4>
      <form className="space-y-4 text-[#534F4F]" id="lws-addProductForm">
        {/* <!-- product name --> */}
        <div className="space-y-2">
          <label htmlFor="lws-inputName">Product Name</label>
          <input
            className="addProductInput"
            id="lws-inputName"
            type="text"
            name="name"
            value={name}
            onChange={handleChange}
            required
          />
        </div>
        {/* <!-- product category --> */}
        <div className="space-y-2">
          <label htmlFor="lws-inputCategory">Category</label>
          <input
            className="addProductInput"
            id="lws-inputCategory"
            type="text"
            name="category"
            value={category}
            onChange={handleChange}
            required
          />
        </div>
        {/* <!-- product image url --> */}
        <div className="space-y-2">
          <label htmlFor="lws-inputImage">Image Url</label>
          <input
            className="addProductInput"
            id="lws-inputImage"
            type="text"
            name="image"
            value={image}
            onChange={handleChange}
            required
          />
        </div>
        {/* <!-- price & quantity container --> */}
        <div className="grid grid-cols-2 gap-8 pb-4">
          {/* <!-- price --> */}
          <div className="space-y-2">
            <label htmlFor="ws-inputPrice">Price</label>
            <input
              className="addProductInput"
              type="number"
              name="price"
              value={price}
              onChange={handleChange}
              id="lws-inputPrice"
              required
            />
          </div>
          {/* <!-- quantity --> */}
          <div className="space-y-2">
            <label htmlFor="lws-inputQuantity">Quantity</label>
            <input
              className="addProductInput"
              type="number"
              name="quantity"
              value={quantity}
              onChange={handleChange}
              id="lws-inputQuantity"
              required
            />
          </div>
        </div>
        {/* <!-- submit button --> */}
        <button
          type="submit"
          id="lws-inputSubmit"
          className="submit"
          onClick={handleSubmit}
          disabled={!isValid}
        >
          Add Product
        </button>
      </form>
    </div>
  );
};

export default AddProductForm;
